// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation_root__13DP0","wallpaper":"Navigation_wallpaper__2X0qA","header":"Navigation_header__XfuQ9","items":"Navigation_items__iRAtX","body":"Navigation_body__2w991"};